import { ReportDiff } from '../models/ReportDiff';
import { ReportDiffStateMapper } from './ReportDiffStateMapper';
import { ReportDiffCountMapMapper } from './ReportDiffCountMapMapper';

export class ReportDiffMapper {
  private readonly reportDiffStateMapper = new ReportDiffStateMapper();
  private readonly reportDiffCountMapMapper = new ReportDiffCountMapMapper();

  mapGQLModel(data: any): ReportDiff {
    return new ReportDiff(
      this.reportDiffStateMapper.mapState(data.state),
      this.reportDiffCountMapMapper.mapGQLModel(data.instancesCount0),
      this.reportDiffCountMapMapper.mapGQLModel(data.instancesCount1),
      this.reportDiffCountMapMapper.mapGQLModel(data.rulesCount0),
      this.reportDiffCountMapMapper.mapGQLModel(data.rulesCount1)
    );
  }
}
